// extracted by mini-css-extract-plugin
module.exports = {"input-container":"Yq9By","input-suffix":"krTi4","numeric":"u8zdb","input":"qkzFW"};